import { objectToFormData as transform } from 'object-to-formdata'

export const objectToFormData = (object: any) => transform(object, { indices: true })
